export const en = {
    "k_5686ea01": "Webhook",
    "k_96322eac": "Promise AI pages are temporarily not supported as embedded page slices",
    "k_2f890239": "[xy-client][useDepLoader] dependency loading failed",
    "k_f98a3b9e": "The current page is developed in low code and does not support this mode",
    "k_44b4dc13": "DB-Data Sheet",
    "k_4f12a877": "Additions and deletions to search",
    "k_786b2537": "DB-Executing SQL",
    "k_709cc99": "Execute SQL statements",
    "k_d57cec90": "DB-MySQL multi-table reading and writing",
    "k_bf0b48a3": "Multi-table transaction operations, associated queries",
    "k_b6d8fa18": "DB-Cross-service Access",
    "k_9abaec66": "Access DB for other infinite deployment versions",
    "k_21ee859d": "Single HTTP interface",
    "k_e3d124cf": "Request backend services",
    "k_e8d56b35": "Multiple HTTP interface combinations",
    "k_f44ededf": "Request a set of backend services for additions, deletions, changes and inspections",
    "k_d535dfbd": "Online NodeJs interface",
    "k_9b100090": "Write cloud functions online",
    "k_2808e675": "Multi-table",
    "k_5effd1ed": "Cross-service access",
    "k_2ff29f11": "Data source management",
    "k_cfc6e07b": "Search for name or ID",
    "k_e49675ea": "New data source",
    "k_d750f9ea": "Person in charge",
    "k_d1237f61": "Please enter the copied data source ID and confirm",
    "k_505cc820": "Log",
    "k_3867da40": "Are you sure you want to delete this data source?",
    "k_3639321c": "No eligible data source",
    "k_efdd4037": "Please add data sources",
    "k_7f68929f": "Replication successful, new ID: {arg_0}",
    "k_fc000d6f": "Replication failed, the same ID already exists: {arg_0}",
    "k_2cc75c11": "Replication failed, error message: {arg_0}'",
    "k_74aaee49": "Deleted successfully",
    "k_c1432dc4": "Delete failed {arg_0}",
    "k_65311841": "Failed to load data source {arg_0}",
    "k_f49783df": "Failed to load data source label {arg_0}",
    "k_2d184bba": "{arg_0}AI Editor",
    "k_ad67c8e5": "Stepless application",
    "k_f7e11c2b": "The targetAppId parameter is incorrect",
    "k_384ed964": "Form verification failed",
    "k_9ad96c5": "Authorization failure",
    "k_89037c4a": "User actively closes pop-up window",
    "k_8bfcb1b2": "Request failed",
    "k_6a2b405f": "Unknown error, please close it and try again",
    "k_f53e7551": "Please enter database ID",
    "k_8e274d07": "Database ID can only contain letters, numbers, and underscores",
    "k_c5fc15ae": "Please enter database name",
    "k_3e171061": "Please enter database administrator",
    "k_1cf6b255": "Database ID",
    "k_1a6ef279": "Please enter the database ID, only letters, numbers and underscores can be used",
    "k_8d07ee98": "Database name",
    "k_ff9765da": "Please enter the database name. It is recommended to enter a readable Chinese name",
    "k_b9cfa038": "Database description",
    "k_25843d47": "Administrator",
    "k_1b84af24": "List interface",
    "k_698232fc": "Original data structure",
    "k_f1da09d1": "Total number of inquiries",
    "k_c73953ea": "New interface",
    "k_6a2a5942": "Update interface",
    "k_6b4ec409": "Acquisition interface",
    "k_f3e62c43": "Delete interface",
    "k_f521a78d": "Current data structure",
    "k_38c3b4b6": "Failed to create/update the knowledge base:",
    "k_85bbf3d2": "Failed to obtain the knowledge base:",
    "k_b9b995ef": "Failed to search the knowledge base:",
    "k_766b1f79": "Failed to obtain project repository permissions: {arg_0}",
    "k_217b2bac": "Failed to add/update project knowledge base permissions:",
    "k_232724b3": "Failed to delete project repository permissions:",
    "k_dd01abf3": "Home page",
    "k_7f2db976": "\n  /**\n   * Current global constant instance\n   * @usage import { getGlobal } from '@wujibase/wuji';\n   */\n  export function getGlobal(): {arg_0}",
    "k_f809c1f9": "Branch merge parameter detected:",
    "k_f9aaeff7": "Merge {arg_0} to {arg_1} branch",
    "k_2419574a": "Branch merge successfully",
    "k_a478b3e7": "AI project merge failed:",
    "k_7439deb": "Branch merge failed: {arg_0}",
    "k_686720b7": "Dependent build failed. Please open the console to view details",
    "k_c4d963d7": "Compilation failed",
    "k_2c2d17dc": "File compilation failed. Are you sure you want to continue publishing?",
    "k_d02e5af9": "Conflict resolved",
    "k_3ba7f23c": "AI project merged successfully",
    "k_e7271902": "Perform an approval",
    "k_ad9624e": "Withdraw (cancel approval)",
    "k_7fa12955": "Comment",
    "k_a0e3c987": "Get all process sheets",
    "k_debc3160": "Search flow sheet by type",
    "k_348de085": "For example: what I initiated, what I participated in, related to me, pending approval",
    "k_4ad61a69": "Pending"
};
